import React, { useEffect } from "react";
import { useLanguage } from "../../src/context/LanguageContext";
import ReactSelect from "react-select";
import  { components } from 'react-select';
const { ValueContainer, Placeholder } = components;



const ConfirmPopup = (props: any) => {
    const {translations} = useLanguage();
    // const [isFocused, setIsFocused] = useState(false);
    let {show, popoupError} = props;
    useEffect(()=>{
        if(show) document.body.classList.add("overflow-hidden");
        return ()=>{
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])

    const CustomValueContainer = (props: any) => {
      return (
        <ValueContainer {...props}>
          <Placeholder {...props} isFocused={props.isFocused}>
            {props.selectProps.placeholder}
          </Placeholder>
          {React.Children.map(props.children, (child: any) =>
            child && child.type !== Placeholder ? child : null
          )}
        </ValueContainer>
      );
    };

    return (
        <div className="mark-lost-popup deleteConfirmation-popup">
            <div className="modal display-block" role="dialog">
                <section className="modal-main" role="document">
                    <div className="modal-header">
                        {
                        !props.isConfirmNotVisible &&
                            <h2 className="modal-title">{props.title || translations.commonMsg?.['Confirm'] || translations.commonMsg?.loading}</h2>
                        }
                        <button type="button" className="close_icn" data-dismiss="modal" aria-label="Close" onClick={() => {
                            props.confirmNo();
                        }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <h3>{props.message || "Are you sure to want to delete?"}</h3><br></br>
                    </div>
                    
                    {
                        props.isReasonVisible && 
                        <div className="single-select">
                            <div className="material">
                         <ReactSelect
                            components={{ ValueContainer: CustomValueContainer }}
                            options={props.reasonList}
                            onChange={(e: any) => props.handleChange(e.value, "reason_id")}
                            value={props.reasonList.find((x: any) => x.value === props.selectedReason)}
                            placeholder={props.placeholder || ""}
                            className="react-select"
                            classNamePrefix="react-select"
                            isSearchable={false}
                            // onFocus={() => setIsFocused(true)}
                            // onBlur={() => setIsFocused(false)}
                        />
                       {
                           popoupError.reason_id && <span className="error-txt">{popoupError.reason_id}</span>
                       }
                        </div>
                        </div>
                    }

                    {
                        (props.isReasonVisible || props?.allowComment) && 
                         <fieldset className="p-lg-t confirmation-textarea">
                            <div className="material">
                           
                            <textarea 
                                onChange={(e: any) => props.handleChange(e.target.value, "comment")} 
                                placeholder={props?.allowComment ? translations.commonMsg?.['REJECT_REASON_DOC']:  translations.commonMsg?.['REJECT_REASON_SHARE'] }
                                className="form-input"
                                
                            >
                                </textarea>
                                 {
                                    popoupError?.comment && <span className="error-txt">{popoupError?.comment}</span>
                                 }
                            {/* <label data-label="Please Share the reason for declning the policy*" className="form-label"></label> */}
                           
                        </div>
                        </fieldset>
                    }
                    
                    
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary btn-lg m-sm-r wd105" onClick={() => {
                            props.confirmYes();
                        }}>{props.isReasonVisible ? 
                            (translations.commonMsg?.['reject'] || translations.commonMsg?.loading)
                            : props?.is_reupload ? (translations.commonMsg?.['Yes'] || translations.commonMsg?.loading) 
                            : (translations.commonMsg?.['Approve'] || translations.commonMsg?.loading)}</button>

                        <button type="button" className="btn btn-line" onClick={() => {
                            props.confirmNo();
                        }}>{translations.commonMsg?.['cancel'] || translations.commonMsg?.loading}</button>
                        
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ConfirmPopup;